// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a3703574","952":"414b0c5c"}[chunkId] + ".chunk.js";
};